import { __name } from './chunk-7QVYU63E.js';
import { z } from 'zod';

// ../../node_modules/@jwplayer/fe-common/module/cookies/index.js
function isDefined(v) {
  return !(typeof v === "undefined");
}
__name(isDefined, "isDefined");
function formatCookie(key, value, config) {
  if (key.trim() === "") {
    throw new Error("Key may not be empty");
  }
  return [
    `${key}=${value}`,
    ...Object.entries(config ?? {}).map(([configKey, configValue]) => {
      if (typeof configValue === "undefined") {
        return;
      }
      if (configValue === true) {
        return configKey;
      }
      if (configValue instanceof Date) {
        configValue = configValue.toUTCString();
      }
      return `${configKey}=${configValue}`;
    })
  ].filter(isDefined).join("; ");
}
__name(formatCookie, "formatCookie");
function setCookie(key, value, config) {
  const cookieString = formatCookie(key, value, config);
  document.cookie = cookieString;
}
__name(setCookie, "setCookie");
function deleteCookie(key, config) {
  document.cookie = formatCookie(key, "", {
    ...config,
    "Max-Age": -999999
  });
}
__name(deleteCookie, "deleteCookie");
function getCookie(key) {
  const cookies = document.cookie.split(";").map((i) => i.trim());
  for (const cookie of cookies) {
    const parts = cookie.split("=");
    if (parts.length < 2) {
      continue;
    }
    const name = parts.shift();
    if (name === key) {
      return parts.join("=");
    }
  }
  return void 0;
}
__name(getCookie, "getCookie");
function createCookieManager(config) {
  let _config = config;
  return {
    setConfig(config2) {
      _config = config2;
    },
    getCookie,
    setCookie: /* @__PURE__ */ __name((key, value, config2) => {
      setCookie(key, value, { ...config2, ..._config });
    }, "setCookie"),
    deleteCookie: /* @__PURE__ */ __name((key, config2) => {
      deleteCookie(key, { ...config2, ..._config });
    }, "deleteCookie")
  };
}
__name(createCookieManager, "createCookieManager");

// ../base/util/environment.ts
function getEnvVariable(variable) {
  if (typeof window !== "undefined") {
    let env;
    try {
      env = import.meta.env[variable];
    } catch (error) {
    }
    return env;
  }
  if (typeof process !== "undefined" && "versions" in process && typeof process.versions === "object" && "node" in process.versions && typeof process.versions.node === "string") {
    return process.env[variable];
  }
  throw new Error("Unsupported environment");
}
__name(getEnvVariable, "getEnvVariable");
function getDomain() {
  if (typeof window === "undefined") {
    return void 0;
  }
  return window.location.hostname.includes("jwplayer.com") ? "jwplayer.com" : void 0;
}
__name(getDomain, "getDomain");

// ../base/auth/cookies.ts
var cookieManager = createCookieManager({
  Path: "/",
  // Ensure we are setting the cookie on our root domain, not on the
  // specific subdomain (e.g `dev-dashboard.jwplayer.com`).
  Domain: getDomain(),
  // Secure cookies not support in test environment
  Secure: getEnvVariable("TEST") ? void 0 : true,
  SameSite: "strict"
});
var zAuthFromAdminMetadata = z.object({
  readOnly: z.boolean(),
  username: z.string(),
  date: z.string()
});
function isAuthFromAdminMetadata(data) {
  return Boolean(
    data && typeof data === "object" && "readOnly" in data && typeof data.readOnly === "boolean" && "username" in data && typeof data.username === "string" && data.username && "date" in data && typeof data.date === "string" && data.date
  );
}
__name(isAuthFromAdminMetadata, "isAuthFromAdminMetadata");
function isAuthFromAdminPayload(data) {
  return isAuthFromAdminMetadata(data) && "authToken" in data && typeof data.authToken === "string";
}
__name(isAuthFromAdminPayload, "isAuthFromAdminPayload");
function decodePayload(str) {
  const payload = JSON.parse(atob(str));
  if (!isAuthFromAdminPayload(payload)) {
    throw new Error("Invalid payload");
  }
  return payload;
}
__name(decodePayload, "decodePayload");
function getAuthFromAdminPayloadFromUrl(queryParam) {
  const usp = new URLSearchParams(window.location.search);
  const value = usp.get(queryParam);
  if (!value) {
    return;
  }
  try {
    return decodePayload(value);
  } catch (err) {
    console.warn("Login through admin failed. Invalid payload.");
  }
}
__name(getAuthFromAdminPayloadFromUrl, "getAuthFromAdminPayloadFromUrl");
function getAuthFromAdminMetadataFromCookie(cookieName) {
  const value = cookieManager.getCookie(cookieName);
  if (!value) {
    return;
  }
  try {
    const meta = JSON.parse(value);
    if (isAuthFromAdminMetadata(meta)) {
      return meta;
    }
  } catch (err) {
  }
}
__name(getAuthFromAdminMetadataFromCookie, "getAuthFromAdminMetadataFromCookie");

export { cookieManager, getAuthFromAdminMetadataFromCookie, getAuthFromAdminPayloadFromUrl, getEnvVariable, zAuthFromAdminMetadata };
//# sourceMappingURL=chunk-YYYI4WOV.js.map
//# sourceMappingURL=chunk-YYYI4WOV.js.map